import { ArrowLeft, ShieldAlert } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

export function AccessDenied() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="mb-6">
          <ShieldAlert className="h-16 w-16 text-red-500 mx-auto" />
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          You don't have access to this area
        </h1>

        <p className="text-gray-600 mb-6">
          This part of Cash Forecaster isn't available with your current account
          settings. If you think you should have access, contact your system
          administrator.
        </p>

        <Link
          to="/dashboard"
          className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Return to Dashboard
        </Link>
      </div>
    </div>
  );
}
